import { QueryClient } from 'react-query';

/**
 * Default retry logic.
 *
 * react-query's built-in default is 3 retries.  We preserve that behaviour
 * for every error EXCEPT maintenance-mode errors, which should not be retried
 * because the service is intentionally unavailable and will return 503 on
 * every retry until the window ends.
 *
 * @param {number} failureCount - Number of failures so far (0-indexed after first failure)
 * @param {Error}  error        - The error thrown by the query function
 * @returns {boolean}
 */
const defaultRetry = (failureCount, error) => {
  if (error && error.isMaintenance) return false;
  return failureCount < 3;
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: defaultRetry
    }
  }
});
